import React, { useEffect } from "react";
import { Row, Col } from "react-bootstrap";

import DtsReactTable from "../../reuseableComponents/dtsReactTable/DtsReactTable";
import { numberWithCommas } from "../../../utilities/commonFunctions/formattingFunctions";

const EpaHealthCalculationsTbl = ({ data }) => {
  const columns = [
    {
      Header: "",
      accessor: "name",
      width: 200
    },
    {
      Header: "Affected",
      accessor: (d) => {
        return d.affectedCnt ? numberWithCommas(d.affectedCnt) : "";
      },
      width: 100
    },
    {
      Header: "Total",
      accessor: (d) => {
        return d.totalCnt ? numberWithCommas(d.totalCnt) : "";
      },
      width: 100
    },
    {
      Header: "Standard",
      accessor: "standard",
      width: 325
    },
    {
      Header: "Actual",
      accessor: (d) => {
        return d.actualPercent ? d.actualPercent.toFixed(2) + "%" : "";
      },
      width: 100
    },
    {
      Header: "Target",
      accessor: "targetPercent",
      width: 100
    }
  ];

  useEffect(() => {
    if (data && data.length) console.log("STANDARDS: ", data);
  }, [data]);

  return (
    <>
      <Row>
        <Col>
          <h3>EPA Health Calculations</h3>
        </Col>
      </Row>
      <Row>
        <Col>
          {data.length > 0 ? (
            <DtsReactTable data={data} columns={columns} headerColor='ddw' cypressid='epaHealthCalcTbl' />
          ) : (
            ""
          )}
        </Col>
      </Row>
    </>
  );
};

export default EpaHealthCalculationsTbl;
